const getVisibleModules = (modules, currentAccount) => {
	const primaryModules = modules.filter(module => ['submodule','child'].indexOf(module.subtype) === -1 && !!module.can_view);
	const access = currentAccount.access || false;
	if (!access) return [];
	if (access.access_type !== 'BASIC') return primaryModules;

	const permissions = (access.access_permissions || []).split(',').filter(Boolean);
	return primaryModules.filter(module => {
		return permissions.indexOf(module.slug) !== -1;
	});
};


export default getVisibleModules;
